var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isOpen && _vm.isActive && _vm.infoBar.content)?_c('div',{class:[
      'info-bar',
      _vm.color && ("bg-" + _vm.color),
      _vm.modulaStyle && 'modulaInfoBar' ]},[_c('cms-renderer',{staticClass:"hint-text",attrs:{"markdown":_vm.infoBar.content}}),_vm._v(" "),_c('span',{staticClass:"close-btn",on:{"click":_vm.closeHint}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }